import {
  RECEIVE_STATION_DETAIL,
  CHANGE_TIMETABLE_COLLAPSED,
} from '../actions'
import MasterData from '../data/MasterData'

const initialState = {
  station: null,
  streetViewUrl: null,
  hasIncidents: false,
  timetables: [],
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_STATION_DETAIL:
      const {
        station,
        street_view_url,
        sotetsu_operation_incidents,
        timetables,
      } = action.payload
      return {
        ...state,
        station: {...station, ...MasterData.station(station.id)},
        streetViewUrl: street_view_url,
        hasIncidents: 0 < sotetsu_operation_incidents.length,
        timetables: timetables.map(timetable => (
          {...timetable, isCollapsed: false}
        )),
      }
    case CHANGE_TIMETABLE_COLLAPSED:
      const { index, isCollapsed } = action
      return {
        ...state,
        timetables: state.timetables.map((timetable, i) => 
          i === index 
            ? { ...timetable, isCollapsed } 
            : timetable
        ),
      }
    default:
      return state
  }
}

export default reducer